import {loadDrive} from './GoogleDriveApi';
import axios from 'axios';
import httpRequest from "./httpRequests"
/**
 * Check if the file is public.
 * @param {*} fileId ID of the file to retrieve permissions for.
 * @param {*} callback return true if the file is public. 
 */
function isFilePublic(fileId, callback, isSettings) {
    let isPublic = false;

    retrievePermissionsListByFileId(fileId, (permissions) => {
         if(permissions) {
            permissions.forEach((permission) => {
               if(permission.type === 'anyone') {
                    isPublic = true;
                 }
             }); 
         }
       callback(isPublic, fileId);  
    },isSettings);
}

/**
 * Retrieve a list of permissions.
 *
 * @param {String} fileId ID of the file to retrieve permissions for.
 * @param {Function} callback Function to call when the request is complete.
 */
function retrievePermissionsListByFileId(fileId, callback,isSettings) {
    if(!fileId || typeof fileId == 'undefined')
        callback('');
    const getPermissionsLis = () => {
        let isSettings = window.location.pathname.indexOf("/settings/popup") > -1 ? 1 : 0;
        if (isSettings){
            const request = window.gapi.client.drive.permissions.list({
                'fileId': fileId
            });     
            request.execute(function(resp) {
                           callback(resp.items);
            });
        }
        else{
            axios.get("api/getPermissionFile"+ httpRequest.getUrlQuery()+ "&fileId=" + fileId)
            .then(resp => {
                callback(resp.data);
            });
        }
    };
    loadDrive(getPermissionsLis, isSettings);
}

/**
 * Update a permission's role.
 *
 * @param {String} fileId ID of the file to update permission for.
 * @param {String} permissionId ID of the permission to update.
 * @param {String} newRole The value "owner", "writer" - editable or "reader" - view.
 */
function updatePermission(fileId, permissionId, newRole, callback) {
    // First retrieve the permission from the API.
    var request = window.gapi.client.drive.permissions.get({
      'fileId': fileId,
      'permissionId': permissionId
    });
    request.execute(function(resp) {
      resp.role = newRole;
      var updateRequest = window.gapi.client.drive.permissions.update({
        'fileId': fileId,
        'permissionId': permissionId,
        'resource': resp
      });
      updateRequest.execute(function(resp) {
        callback(resp)
       });
    });
}

/**
 * Update file role.
 * @param {*} fileId ID of the file to retrieve permissions for.
 * @param {String} newRole The value "owner", "writer" - editable or "reader" - view. 
 */
function updateFilePermission(fileId, newRole, callback) {
 
    retrievePermissionsListByFileId(fileId, (permissions) => {
        if(permissions) {
            permissions.forEach((permission) => {
                 if(permission.type === 'anyone'  ) {
                    updatePermission(fileId, permission.id, newRole, callback);
                }
            });
        }
    });
   
}

/**
 * Update file role.
 * @param {*} fileId ID of the file to retrieve permissions for.
 * @param {String} newRole The value "owner", "writer" - editable or "reader" - view. 
 */
function checkIfFileEditable(fileId, callback) {
   let fileEditable=false;
    retrievePermissionsListByFileId(fileId, (permissions) => {
        
        if(permissions) {
            permissions.forEach((permission) => {
                if(permission.type === 'anyone' && permission.role === 'writer') {
                    fileEditable=true;
                }
            }
        ); 
        }
         callback(fileEditable); 
    });
}

/**
 * Insert a new permission.
 *
 * @param {String} fileId ID of the file to insert permission for.
 * @param {String} value User or group e-mail address, domain name or
 *                       {@code null} "default" type.
 * @param {String} type The value "user", "group", "domain" or "default".
 * @param {String} role The value "owner", "writer" or "reader".
 */
function insertPermission(fileId, value, type, role, callback) {
    const insert = () => {
        const body = {
            'value': value,
            'type': type,
            'role': role
        };
        const request =  window.gapi.client.drive.permissions.insert({
            'fileId': fileId,
            'resource': body
        });
        request.execute(function(resp) { 
            if(callback)
                callback(resp);
        });
    };
    loadDrive(insert);
}

/**
 * Remove a permission.
 *
 * @param {String} fileId ID of the file to remove the permission for.
 * @param {String} permissionId ID of the permission to remove.
 */
function removePermission(fileId, permissionId) {

    const deletePermission = () => {
        var request = window.gapi.client.drive.permissions.delete({
            'fileId': fileId,
            'permissionId': permissionId
        });

        request.execute(function(resp) {
        });
    };
    loadDrive(deletePermission);
}

export {
    retrievePermissionsListByFileId, 
    checkIfFileEditable,
    updateFilePermission,
    updatePermission,
    insertPermission,
    removePermission,
    isFilePublic,
}




// WEBPACK FOOTER //
// ./src/widget/api/PermissionsAPI.js